export default __webpack_public_path__ + "static/media/image19.b2454d11.jpg";